import { Link } from 'react-router-dom';

import { routes } from '@/app/router/route-paths';
import logoMark from '@/assets/icons/AA logo.svg';
import { cn } from '@/shared/utils/cn';

/**
 * Brand lockup: AA monogram + AYAT wordmark. `compact` drops the sub-label for
 * tight spaces (e.g. mobile bar, footer).
 */
export function Logo({ className, compact = false }) {
  return (
    <Link
      to={routes.home}
      aria-label="Ayat Fragrances — home"
      className={cn('inline-flex flex-row items-center gap-2 leading-none', className)}
    >
      <img
        src={logoMark}
        alt=""
        className="-mr-3 h-11 w-11 shrink-0 object-contain sm:-mr-4 sm:h-14 sm:w-14"
        aria-hidden="true"
      />
      <span className="inline-flex flex-col items-center">
        <span
          className="font-serif text-[1.35rem] font-bold tracking-[0.22em] pl-[0.22em] text-[color:var(--color-ink)] sm:text-[1.7rem] sm:tracking-[0.3em] sm:pl-[0.3em]"
          style={{ WebkitTextStroke: '0.6px currentColor' }}
        >
          AYAT
        </span>
        {!compact && (
          <span
            className="eyebrow text-[0.36rem] tracking-[0.2em] pl-[0.2em] text-[color:var(--color-ink)]"
            style={{ fontWeight: 500, fontFamily: 'var(--font-serif)' }}
          >
            Fragrances
          </span>
        )}
      </span>
    </Link>
  );
}
